import { NgClass } from "@angular/common";
import { Component, inject, input } from "@angular/core";
import { MatIcon } from "@angular/material/icon";
import { AppService } from "src/app-legacy/core/services/app.service";

@Component({
	selector: "app-bottom-menu-item",
	imports: [MatIcon, NgClass],
	templateUrl: "./bottom-menu-item.component.html",
})
export class BottomMenuItemComponent {
	icon = input.required<string>();

	private appService = inject(AppService);
	isInternalView = this.appService.currentSchool.zfInternalViewSchool === "YES";
}
